import { Devis } from '@/models/Devis';

export interface DemandeDevis {
    id: number;
    objet: string;
    description: string;
    delai: string;
    devis: Devis[];
    status: EtatDemandeDevis;
    date: string;
    site: string;
}

export enum EtatDemandeDevis {
    enAttente = 'EN_ATTENTE',
    enCours = 'EN_CHIFFRAGE',
    cloturee = 'DEVIS_PUBLIE',
}
